import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/rev': {
    width: 410,
    height: 512,
    paths: [
      {
        d: 'M270.7 274.9C270.7 311 241.3 340.5 205.1 340.5S139.5 311 139.5 274.9 168.9 209.3 205.1 209.3 270.7 238.7 270.7 274.9zM410.2 269.8H410.1C408.6 208.3 380 153.5 335.8 116.9L290.4 143.1C333.6 171.1 362.2 219.7 362.2 274.9 362.2 361.5 291.7 432 205.1 432S48 361.5 48 274.9C48 193 111 125.6 191 118.4V157.6L299.8 94.8 191 32V70.3C84.3 77.6 0 166.4 0 274.9 0 386.5 89.1 477.2 200.1 479.9V480H410.2V269.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/rev.js
// module id = iDu+
// module chunks = 144